<template>
  <div>
    <!-- option前置处理设置 -->
    <el-dialog :title="$t('message.preServiceSet')" :close-on-click-modal="false" :visible.sync="dialogVisible"
      width="1288px" center>
      <div class="list">
        <div class="content" v-for="(order, orderIndex) in detailList" :key="orderIndex" v-show="order.show">
          <div class="order_detail">
            <div class="item flex02">
              {{ order.sorting }}
            </div>
            <div class="item flex05">
              <el-image :src="order.pic" style="width: 60px; height: 60px; border-radius: 4px">
                <div slot="placeholder" class="image-slot">
                  加载中<span class="dot">...</span>
                </div>
              </el-image>

            </div>
            <div class="item">
              <el-tooltip placement="bottom" style="height:100px">
                <div slot="content">
                  <div class="row" v-for="(itemDetail, itemIndex) in order.detail_y" :key="itemIndex"
                    style="margin-bottom: 5px">
                    {{ itemDetail.key }}：{{ itemDetail.value }}
                  </div>
                </div>
                <div>
                  <div class="row" v-for="(itemDetail, itemIndex) in order.detail_y" :key="itemIndex"
                    @click="copy(itemDetail.value)">
                    {{ itemDetail.key }}：{{ itemDetail.value }}
                  </div>
                </div>
              </el-tooltip>
            </div>
          </div>
          <div class="optionList">


            <div class="row" v-for="(item, index) in order.list" :key="index">
              <div class="label">
                {{ item.cate_name }}:
              </div>
              <div class="val">
                <div class="item">
                  <el-radio :label="1" v-model="item.pre">{{ item.start }}</el-radio>
                </div>
                <div class="item">
                  <el-radio :label="0" v-model="item.pre">{{ item.end }}</el-radio>
                </div>

              </div>
            </div>
            <!-- 每个单番独立设置系统自动生成 FBA 服务单的操作人员。 -->
            <div class="fba-operator">
              <span class="label">{{ $t('message.fbaPreOperator') }}：</span>
              <el-radio-group v-model="order.fba_pre_operator">
                <el-radio :label="1">{{ $t('message.fbaPreOperatorLeader') }}</el-radio>
                <el-radio :label="2">{{ $t('message.fbaPreOperatorFba') }}</el-radio>
                <el-radio :label="3">{{ $t('message.fbaPreOperatorInspector') }}</el-radio>
              </el-radio-group>
            </div>
          </div>
        </div>
      </div>
      <!-- 批量选择只修改本次展示单番的 FBA 前置操作人员，最终随保存接口统一提交。 -->
      <div class="fba-operator-batch">
        <span class="label">{{ $t('message.fbaPreOperator') }}：</span>
        <el-button type="primary" @click="setAllFbaPreOperator(1)">
          {{ $t('message.fbaPreOperatorAllLeader') }}
        </el-button>
        <el-button type="primary" @click="setAllFbaPreOperator(2)">
          {{ $t('message.fbaPreOperatorAllFba') }}
        </el-button>
        <el-button type="primary" @click="setAllFbaPreOperator(3)">
          {{ $t('message.fbaPreOperatorAllInspector') }}
        </el-button>
        <!-- 批量修改本次选中单番的 FBA 前置状态，最终随保存按钮统一提交。 -->
        <div class="fba-pre-batch-actions">
          <el-button type="primary" @click="setAllFbaPre(1)">
            {{ $t('message.fbaPreAllEnable') }}
          </el-button>
          <el-button type="primary" @click="setAllFbaPre(0)">
            {{ $t('message.fbaPreAllDisable') }}
          </el-button>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!--取 消  -->
        <!-- <el-button @click="$parent.addExpressDialogVisible = false">{{
          $t("message.cancel")
        }}</el-button> -->
        <!-- 保存 -->
        <el-button type="primary" @click="save">{{
          $t("message.save")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {

      order_sn: this.$route.query.order_sn,
      detailList: [],
      selectedOrder: [],
      dialogVisible: false,

    };
  },
  mounted() {

  },
  methods: {
    // 获取option列表
    preServiceGet() {
      console.log(this.selectedOrder);

      this.$api.optionServiceApi.preServiceGet({
        order_sn: this.order_sn,
      }).then(res => {
        res.data.forEach((order) => {
          let orderData = this.selectedOrder.find(item => item.sorting == order.sorting)
          if (orderData) {
            order.show = true
            order.pic = orderData.pic
            order.detail_y = orderData.detail_y
            // 接口顶层已返回保存值时直接回显；字段为空才默认选中检品组长。
            const hasFbaPreOperator = order.fba_pre_operator !== null
              && order.fba_pre_operator !== undefined
              && order.fba_pre_operator !== ''
            const fbaPreOperator = hasFbaPreOperator ? Number(order.fba_pre_operator) : 1
            this.$set(order, 'fba_pre_operator', fbaPreOperator)
            order.list.forEach((item) => {
              item.pre = item.pre - 0

              item.end = '不前置，自由操作'
              if (item.cate_name == '普通服务') {
                item.start = '服务前置处理（检品操作）'
              }
              if (item.cate_name == '机械操作') {
                item.start = '服务前置处理（检品完成后机械操作员操作）'
              }
              if (item.cate_name == '摄影操作') {
                item.start = '服务前置处理（检品完成后摄影人员操作）'
              }
              if (item.cate_name == '布标操作') {
                item.start = '服务前置处理（检品完成后布标人员操作）'
              }
              if (item.cate_name == 'FBA操作') {
                item.start = '服务前置处理（检品完成后检品人员操作）'
              }
            })
          } else {
            order.show = false
          }

        })
        this.detailList = res.data
        this.dialogVisible = true
      })
    },
    // 将本次选中的所有单番统一设置为同一种 FBA 前置操作人员规则。
    setAllFbaPreOperator(value) {
      this.detailList.forEach(order => {
        if (order.show) this.$set(order, 'fba_pre_operator', value)
      })
    },
    // 只批量修改选中单番中的 FBA 操作项，其他服务前置设置保持不变。
    setAllFbaPre(value) {
      this.detailList.forEach(order => {
        if (!order.show) return
        const fbaItem = order.list.find(item => String(item.cate_id) === '5')
        if (fbaItem) this.$set(fbaItem, 'pre', value)
      })
    },
    // 保存
    save() {
      let datas = {
        order_sn: this.order_sn,
        detail_list: []
      }
      this.detailList.forEach((order, index) => {
        if (order.show) {
          let datasItem = {
            order_detail_id: order.order_detail_id,
            list: [],
            fba_pre_operator: order.fba_pre_operator
          }
          order.list.forEach((item, index) => {
            const listItem = {
              cate_id: item.cate_id,
              pre: item.pre,
            }
            // 人员配置跟随每个单番的 FBA 操作项提交，其他服务项不携带该字段。

            datasItem.list.push(listItem)
          })
          datas.detail_list.push(datasItem)
        }

      })
      this.$api.optionServiceApi.preServiceSet(datas).then(res => {
        this.$message.success(res.msg);
        this.dialogVisible = false
        this.$emit('saved')
      })
    },
  },
};
</script>
<style lang='scss' scoped>
.list {
  max-height: 600px;
  overflow: auto;
}

.content {
  margin: 0px 40px;
  display: flex;
  margin-bottom: 20px;
  border-bottom: 1px solid #545467;

  &:last-child(1) {
    margin-bottom: 0;
    border-bottom: none;
  }

  .order_detail {
    width: 280px;
    margin-right: 20px;
    display: flex;

    .item {
      flex: 1;
      display: flex;
      justify-content: center;

    }

    .flex02 {
      flex: 0.2;
      line-height: 60px;
    }

    .flex05 {
      flex: 0.5;
    }
  }

  .optionList {
    flex: 1;
  }

  .row {

    display: flex;
    margin-bottom: 20px;

    .label {
      width: 100px;
    }

    .val {
      flex: 1;
      display: flex;
      justify-content: space-between;

    }
  }


}
.fba-operator {
  display: flex;
  align-items: center;
  margin: 12px 0px 0;
  padding-bottom: 14px;


  .label {
    margin-right: 18px;

    width: 150px;
  }

  /deep/.el-radio {
    margin-right: 24px;
  }
}

.fba-operator-batch {
  display: flex;
  align-items: center;
  padding: 16px 40px 0;

  .label {
    margin-right: 18px;
    font-size: 18px;
    font-weight: bold;
  }

  .el-button {
    min-width: 150px;
  }

  .fba-pre-batch-actions {
    display: flex;
    margin-left: auto;
  }
}
</style>
